import { useEffect, useState } from "react";
import api from "../lib/api";
import { MODULES, ROLE_LABELS } from "../lib/constants";
import { toast } from "sonner";

export default function SuperAdmin() {
  const [users, setUsers] = useState([]);
  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (u, key) => {
    if (u.role === "super_admin") return;
    const has = (u.modules || []).includes(key);
    const modules = has ? u.modules.filter((m) => m !== key) : [...(u.modules || []), key];
    setUsers((us) => us.map((x) => (x.id === u.id ? { ...x, modules } : x)));
    try { await api.put(`/users/${u.id}`, { modules }); } catch { toast.error("Failed"); load(); }
  };

  return (
    <div className="space-y-6">
      <div><h1 className="text-3xl font-head font-extrabold tracking-tight">Super Admin — Module Access</h1>
        <p className="text-muted-foreground">Grant or revoke access to each module per user</p></div>

      <div className="bg-card border border-border rounded-md shadow-sm overflow-x-auto">
        <table className="w-full text-sm" data-testid="access-table">
          <thead><tr className="text-left label-caps border-b border-border">
            <th className="p-3 sticky left-0 bg-card">User</th>
            {MODULES.map((m) => <th key={m.key} className="px-2 text-center">{m.label}</th>)}</tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-b border-border/50">
                <td className="p-3 sticky left-0 bg-card">
                  <div className="font-medium">{u.name}</div>
                  <div className="text-xs text-muted-foreground">{ROLE_LABELS[u.role]}</div>
                </td>
                {MODULES.map((m) => {
                  const on = u.role === "super_admin" || (u.modules || []).includes(m.key);
                  return (
                    <td key={m.key} className="text-center">
                      <input type="checkbox" checked={on} disabled={u.role === "super_admin"}
                        onChange={() => toggle(u, m.key)} data-testid={`access-${u.id}-${m.key}`}
                        className="w-4 h-4 accent-primary" />
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-muted-foreground">Super Admin always has full access and cannot be restricted.</p>
    </div>
  );
}
